import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./addProject.css";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function AddProject() {
  const [name, setName] = useState("");
  const [live, setLive] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const navigate = useNavigate();

  async function handleClick() {
    const data = new FormData();
    data.append("name", name);
    data.append("live", live);
    data.append("description", description);
    data.append("image", image);
    console.log(data);

    axios
      .post(`${process.env.REACT_APP_server}/projects/`, data)
      .catch((err) => console.log(err));

    navigate("/editprojects");
    setOpen(false);
  }
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <button className="edit__btn" onClick={handleClickOpen}>
        Add New Project
      </button>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="main__conatiner"
      >
        <div className="addProject__container">
          <DialogContent dividers>
            <label class="filelabel">
              <i class="fa fa-paperclip"></i>
              <span class="title">Add Image</span>
              <input
                class="FileUpload1"
                id="FileInput"
                name="booking_attachment"
                type="file"
                onChange={(e) => {
                  setImage(e.target.files[0]);
                }}
              />
            </label>

            <Typography>
              <span className="addProject__title">Title</span>

              <input
                onChange={(e) => {
                  setName(e.target.value);
                }}
                className="edit__projects"
                type="text"
              ></input>
            </Typography>

            <Typography>
              <span className="addProject__title">Live Link</span>
              <input
                onChange={(e) => {
                  setLive(e.target.value);
                }}
                className="edit__projects"
                type="text"
              ></input>
            </Typography>
            <Typography>
              <span className="addProject__title">Description</span>

              <textarea
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                className="input__description"
                type="text"
              ></textarea>
            </Typography>
          </DialogContent>

          <DialogActions>
            <button autoFocus onClick={handleClick} className="save__btn">
              Save
            </button>
          </DialogActions>
        </div>
      </BootstrapDialog>
    </div>
  );
}
